import store from "@/store";
import tim from '@/tim';
import api from '@/service/modules/instantMessaging';
import apis from 'apis';

export default [
	{
		path: '/instantMessaging',
		meta: {
			title: '即时通信',
			unwantedSetTitle: true
		},
		beforeEnter: async (to, from, next) => {
			let query = to.query;
			const res = await api.getSign({
				identifier: query.userId
			});
			if (res.ret !== 0) {
				store.commit('instantMessaging/showMessage', {
					message: res.msg,
					type: 'danger'
				});
			}
			tim.login({
				userID: query.userId,
				userSig: res.data.data
			}).then(() => {
				store.commit('instantMessaging/updateCurrentUserRole', 'staff');
				// store.commit('instantMessaging/showMessage', {
				// 	message: '登陆成功'
				// });
				next();
			}).catch(e => {
				store.commit('instantMessaging/showMessage', {
					message: '登录即时通信失败',
					type: 'danger'
				});
			})
		},
		redirect: '/instantMessaging/chatInterface',
		component: () => import(/* instantMessaging: "index" */ '../../pages/instantMessaging/index.vue'),
		children: [
			{
				path: '/instantMessaging/chatInterface',
				meta: {
					title: '即时通信',
					unwantedSetTitle: true
				},
				component: () =>import(/* instantMessaging: "index" */ '../../pages/instantMessaging/views/chatInterface/chatInterface.vue')
			},
		]
	},
	{
		path: '/c_instantMessaging',
		meta: {
			title: '即时通信',
			unwantedSetTitle: true
		},
		beforeEnter: async (to, from, next) => {
			let query = to.query;
			query.userId = `yyn_${query.userId}`;
			query.refundId = `REFUND-${query.refundId}`;
			const res = await api.getSign({
				identifier: query.userId
			});
			if (res.ret !== 0) {
				store.commit('instantMessaging/showMessage', {
					message: res.msg,
					type: 'danger'
				});
			}
			tim.login({
				userID: query.userId,
				userSig: res.data.data
			}).then(() => {
				store.commit('instantMessaging/updateCurrentUserRole', 'custom');
				// store.commit('instantMessaging/showMessage', {
				// 	message: '登陆成功'
				// });
				next();
			}).catch(e => {
				store.commit('instantMessaging/showMessage', {
					message: '登录即时通信失败',
					type: 'danger'
				});
			});
		},
		redirect: '/c_instantMessaging/chatInterface',
		component: () => import(/* instantMessaging: "index" */ '../../pages/instantMessaging/index.vue'),
		children: [
			{
				path: '/c_instantMessaging/chatInterface',
				meta: {
					title: '即时通信',
					unwantedSetTitle: true
				},
				component: () =>import(/* instantMessaging: "index" */ '../../pages/instantMessaging/views/chatInterface/chatInterface.vue')
			},
		]
	},
	{
		path: '/personalChat',
		meta: {
			title: '个人聊天',
			unwantedSetTitle: true
		},
		beforeEnter: async (to, from, next) => {
			let query = to.query;
			const  type  = to.query.currentConversationType
			
			if (type === 'C2C') {
				console.log('个人聊天-----')
				query.chatId = `yjg_${query.targetId}`;
				if (!query.userId) {
					return next();
				}
				query.userId = `yjg_${query.userId}`;

			} else if (type === "GROUP") {
				console.log('群聊跳转')

				query.chatId = `TIO-${query.targetId}`;
				if (!query.userId) {
					return next();
				}
				query.userId = `yjg_${query.userId}`;
			}
	
			const res = await apis.getSign({
				identifier: query.userId
			});
			if (res.ret !== 0) {
				store.commit('instantMessaging/showMessage', {
					message: res.msg,
					type: 'danger'
				});
			}
			tim.login({
				userID: query.userId,
				userSig: res.data
			}).then(() => {
				store.commit('instantMessaging/updateCurrentUserRole', 'custom');
				// store.commit('instantMessaging/showMessage', {
				// 	message: '登陆成功'
				// });
				next();
			}).catch(e => {
				store.commit('instantMessaging/showMessage', {
					message: '登录即时通信失败',
					type: 'danger'
				});
			});
		},
		redirect: '/personalChat/personalChat',
		component: () => import(/* instantMessaging: "index" */ '../../pages/instantMessaging/index.vue'),
		children: [
			{
				path: '/personalChat/personalChat',
				meta: {
					title: '个人聊天',
					unwantedSetTitle: true
				},
				component: () =>import(/* instantMessaging: "index" */ '../../pages/instantMessaging/views/personalChat/personalChat.vue')
			},
		]
	},
	{
		path: '/selectContact',
		meta: {
			title: '选择联系人',
			unwantedSetTitle: true
		},
		component: () => import(/* instantMessaging: "index" */ '../../pages/instantMessaging/views/selectContact/index.vue'),

	},
	{

		path: '/report',
		meta: {
			title: '举报',
			unwantedSetTitle: true
		},
		component: () => import(/* instantMessaging: "index" */ '../../pages/instantMessaging/views/report/report.vue'),
		
	},

]
